import * as React from "react";
import { forwardRef } from "react";
const SvgPosMachine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M31 18V3C31 1.89543 30.1046 1 29 1H7C5.89543 1 5 1.89543 5 3V8",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 7H31",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M1 13.5C1 12.6716 1.67157 12 2.5 12H25.5C26.3284 12 27 12.6716 27 13.5V29.5C27 30.3284 26.3284 31 25.5 31H2.5C1.67157 31 1 30.3284 1 29.5V13.5Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M1 18H27",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 24H8",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M18.5 23C17.8544 22.1391 16.7303 21.788 15.7094 22.1283C14.6886 22.4686 14 23.4239 14 24.5C14 25.5761 14.6886 26.5314 15.7094 26.8717C16.7303 27.212 17.8544 26.8609 18.5 26C19.1456 26.8609 20.2697 27.212 21.2906 26.8717C22.3114 26.5314 23 25.5761 23 24.5C23 23.4239 22.3114 22.4686 21.2906 22.1283C20.2697 21.788 19.1456 22.1391 18.5 23V23Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgPosMachine);
export default ForwardRef;
